import { render, staticRenderFns } from "./expireDetail.vue?vue&type=template&id=015d886d&scoped=true"
import script from "./expireDetail.vue?vue&type=script&lang=js"
export * from "./expireDetail.vue?vue&type=script&lang=js"
import style0 from "./expireDetail.vue?vue&type=style&index=0&id=015d886d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015d886d",
  null
  
)

export default component.exports